var map = {
	"./3clouds.webp": 8241,
	"./API.webp": 238,
	"./akhomich.webp": 5630,
	"./andersen.webp": 9830,
	"./angloamerican.webp": 2665,
	"./c.svg": 2882,
	"./cicd.webp": 1897,
	"./cplusplus.svg": 1274,
	"./css.svg": 8772,
	"./desktopapp.webp": 3969,
	"./globallogic.webp": 1769,
	"./golang.svg": 677,
	"./graphql.svg": 3674,
	"./html.svg": 6132,
	"./javascript.svg": 5602,
	"./jest.svg": 3913,
	"./kafka.svg": 23,
	"./kianmin.webp": 1271,
	"./lua.svg": 2239,
	"./luxoft.webp": 9122,
	"./microservices.webp": 9946,
	"./mongodb.svg": 255,
	"./mysql.svg": 9163,
	"./navalarchitect.webp": 8653,
	"./nginx.svg": 3161,
	"./nodejs.svg": 9338,
	"./nortal.webp": 9706,
	"./nuxt.svg": 4940,
	"./pinia.svg": 554,
	"./postgresql.svg": 7893,
	"./python.svg": 969,
	"./qml.svg": 43,
	"./qt.svg": 524,
	"./rakesh.webp": 7056,
	"./redis.svg": 4696,
	"./sebastian.webp": 8832,
	"./siemens.webp": 2688,
	"./svitla.webp": 2929,
	"./tailwind.svg": 7571,
	"./timescaledb.svg": 2088,
	"./typescript.svg": 3330,
	"./vite.svg": 6493,
	"./vue.svg": 2557,
	"./vuex.svg": 751,
	"./webapp.webp": 9179,
	"./wirepulse.webp": 9556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7328;